import type { ReactNode } from "react";
import styles from "./SectionShell.module.css";

type Props = {
  id: string;
  kicker?: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
  alt?: boolean;
};

export function SectionShell({ id, kicker, title, subtitle, children, alt }: Props) {
  return (
    <section id={id} className={`${styles.shell} ${alt ? styles.alt : ""}`}>
      <div className={styles.inner}>
        {kicker ? <p className={styles.kicker}>{kicker}</p> : null}
        <h2 className={`${styles.title} ${subtitle ? styles.titleWithSub : ""}`}>{title}</h2>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        {children}
      </div>
    </section>
  );
}
